import ElementUI from 'element-ui'

import axios from 'axios'
import store from '../store'
import { withAwait } from '@/utils/hoc'
import DeviceData from '@/utils/device'

var baseURL = process.env.NODE_ENV === 'development'? 
  '/api' : 
  'https://m.admin.cmkipr.com';

const timeout = 30000;
const downloadTimeout = 300000;

const request = axios.create({
  baseURL,
  timeout,
})

const setHeader = config => {
  config.headers['cache-control'] = 'no-cache';
  config.headers['pragma'] = 'no-cache';
  let { token } = store.getters;
  if (token) config.headers['token'] = token;
  let data = config.params || config.data;
  if(data){
    let { NeedDevice } = data;
    if(NeedDevice){
      let deviceData = DeviceData();
      let device = JSON.stringify(deviceData);
      config.headers['device'] = device;
    }
  }
  return config;
}

request.interceptors.request.use(
  async config => setHeader(config),
  error => {
    Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code != 200) {
      if(res.code == 401){
        ElementUI.Message({
          message: '您的账号已登出或登录超时，即将登出...',
          type: 'warning',
          duration: 2000,
          onClose: () => {
            store.dispatch('LogOut');
            location.reload();
          }
        })
      }else{
        ElementUI.Message({
          message: res.msg,
          type: 'info'
        })
      }
      return Promise.reject(res);
    } else {
      return Promise.resolve(res.result);
    }
  },
  error => {
    ElementUI.Message({
      message: error.message,
      type: 'error'
    })
    return Promise.reject({code: error.code, msg: error.message})
  }
)
const download = axios.create({
  baseURL,
  timeout,
  withCredentials: true,
  responseType: 'blob'
})
download.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['lang'] = 'zh-cn';
      config.headers['token'] = store.getters.token;
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)
download.interceptors.response.use(
  async ({headers, data}) => {
    let [ info ] = await withAwait(data.text());
    let type = headers['content-type']
    //下载错误
    if(type && type.indexOf('application/json') != -1){
      ElementUI.Message({
        message: '下载失败：'+ JSON.parse(info).msg,
        type: 'error'
      })
      return Promise.reject(info)
    }
    //下载成功！
    let filename = headers['filename'];
    return {
      filename,
      data
    };
  },
  error => {
    ElementUI.Message({
      message: '下载失败：'+error,
      type: 'error'
    })
    return Promise.reject(error)
  }
)
export {
  request,
  download
}



// WEBPACK FOOTER //
// ./src/api/request.js